<template>
  <b-modal
      id="form-newsletter-test-send-modal"
      ref="form-newsletter-test-send-modal"
      cancel-variant="outline-secondary"
      ok-title="Próbaküldés"
      cancel-title="Mégsem"
      @ok.prevent="handleOk"
      centered
      title="Próbaküldés"
  >
    <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        rounded="sm"
    >
    <!-- form -->
      <validation-observer ref="simpleRules">
      <b-form>
        <b-row>
          <b-col md="12">
            <b-form-group
                label="Email cím"
            >
              <validation-provider
                  #default="{ errors }"
                  name="email cím"
                  rules="required|email"
                  vid="email"
              >
                <b-form-input
                    v-model="formData.email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="teszt@maconka.hu"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              <b-alert show variant="info" class="mt-2 p-2">* Csak a rendszerben létező felhasználónak küldhető próbaküldés, ennek az oka, hogy a hírlevélben megszólítjuk a felhasználót, ha nincs az e-mail címhez felhasználó párosítva, a név hiánya miatt hibára futna a próbaküldés.</b-alert>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    </b-overlay>
  </b-modal>
</template>

<script>

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BFormCheckbox, BOverlay, BAlert
} from 'bootstrap-vue'
import {
  required, email,
} from '@validations'
import vSelect from 'vue-select'
import BCardCode from "@core/components/b-card-code";

export default{
  components: {
    BOverlay,
    BAlert,
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    vSelect,
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      role: 'newsletter',
      formData: {
        id: '',
        email: '',
      },
      loading: false,
      required,
      email,
    }
  },
  created() {
    this.formData.id = this.id
    this.formData.email = this.$store.getters.user.email
  },
  methods: {
    handleOk() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.loading = true
          // clone formData
          let fd = JSON.parse(JSON.stringify(this.formData))

          this.$store.dispatch('newsletterTestSend', fd).then(() => {
            this.$helpers.showSuccessToast()
            this.$bvModal.hide("form-newsletter-test-send-modal");
            this.$emit('test-sent')
          }).catch(error => {
            if (error.response.status === 422) {
              this.$refs.simpleRules.setErrors(error.response.data.errors)
            } else {
              this.$helpers.showErrorToast(error.toString())
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
  },
}
</script>
